import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IAppState, isUserShareMember } from '@mafc/common';
import { deleteCartEntries } from '../redux/actions/updateQuantity.action';
import { INewCartEntry } from '../ICart';

const useOOSItems = (entries: INewCartEntry[]) => {
  const dispatch = useDispatch();
  const [isOOSInfoOpen, setOOSInfo] = useState(false);
  const store = useSelector((state: IAppState) => state);
  const sessionArea = store.sessionArea;
  const isShareUser = isUserShareMember(store);

  const deleteAllItems = () => {
    deleteCartEntries(
      dispatch,
      entries.map(({ offerId, entryNumber }) => ({
        cartEntryNumber: entryNumber,
        offerId,
      })),
      sessionArea,
      isShareUser
    );
  };

  const openOOSInfo = () => setOOSInfo(true);

  const closeOOSInfo = () => setOOSInfo(false);

  return {
    isOOSInfoOpen,
    deleteAllItems,
    openOOSInfo,
    closeOOSInfo,
  };
};

export default useOOSItems;
